import { Typography } from "@mui/material";

import { Props } from "./interfaces";
import { Container, Overlay } from "./styles";
import Spinner from "../Spinner/Spinner";

const LoadingOverlay = ({
  loading,
  error,
  children,
  spinner = true,
  spinnerSize = "4x",
  opaqueBKG = true,
  isSpinnerPositionAbsolute,
  customSpinnerStyle,
}: Props) => {
  return (
    <Container>
      {error && (
        <Typography
          color="error"
          style={{ textAlign: "center", fontSize: "1.3rem" }}
        >
          {error}
        </Typography>
      )}
      {loading && (
        <Overlay opaqueBKG={opaqueBKG}>
          {spinner && (
            <Spinner
              customStyle={customSpinnerStyle}
              isPositionAbsolute={isSpinnerPositionAbsolute}
              size={spinnerSize}
            />
          )}
        </Overlay>
      )}
      {children}
    </Container>
  );
};

export default LoadingOverlay;
